import clsx from 'clsx';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../../EmptyFragment';
import { ProductLicenseResource } from '../../../../../../../Types';
import Heading from '../../../../../../Edit/CurrentCollectionStep/Heading';
import LearningCollectionEditStore from '../../../../../../Edit/Store';
import { ExperienceResource } from '../../../Types';
import AvailableStartDates from '../../AvailableStartDates';
import Description from '../../Description';
import ExperienceHours from '../../ExperienceHours';
import OfferingType from '../../OfferingType';
import OnDemand from '../../OnDemand';

export interface Props {
  resource: ExperienceResource;
  productLicense: Maybe<ProductLicenseResource>;
  learningCollectionStore: LearningCollectionEditStore;
}

function BodyLeft({ resource, learningCollectionStore, productLicense }: Props) {
  return (
    <div className="basis-2/3">
      <Heading title={resource.payload.title.text} featured={resource.payload.featured} />
      <div className="flex">
        <div
          className={clsx('opacity-1', { 'opacity-70': resource.payload.status === 'Unlicensed' })}
        >
          <OfferingType resource={resource} />
        </div>
        <ExperienceHours resource={resource} />
        <OnDemand resource={resource} />
      </div>
      <div className="mb-5 text-xs">
        <Description resource={resource} />
      </div>
      {productLicense
        .map((productLicense) => (
          <AvailableStartDates
            resource={resource}
            learningCollectionStore={learningCollectionStore}
            productLicense={productLicense}
          />
        ))
        .getOrElse(emptyFragment)}
    </div>
  );
}

export default observer(BodyLeft);
